import { isEmpty } from 'lodash'

import cardFlag from 'helpers/cardFlag'

import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE } = validations

const cardNumber = {
  name: 'cardNumber',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'Cartão inválido') {
    return this.test(
      'cardNumber',
      message,
      (value) => isEmpty(value) || !!cardFlag.identify(value),
    )
  },
}

export default cardNumber
